import { STATUS_COMPLETED, STATUS_FINISHED, STATUS_PENDING } from '@constants/live/status.js'

export const nextStatus = {
  [STATUS_PENDING]: STATUS_COMPLETED,
  [STATUS_COMPLETED]: STATUS_FINISHED,
}
